module.exports = __webpack_public_path__ + "static/bg-8f61f4d4f8e590d35ce2445f7f942643.png";